import _Unit from './model';

export const Unit = _Unit;

export default Unit;



// WEBPACK FOOTER //
// ./data/Mentor/model/index.js